module.exports = __webpack_public_path__ + "static/media/108.27ce6110.png";